import React, { useEffect, useState, lazy, Suspense, useContext } from "react";
// import { IFront } from "../../components/cars/front/850i";
// import { IRear } from "../../components/cars/rear/850i";
// import { PORGTFront } from "../../components/cars/front/PORGT";
// import { PORGTRear } from "../../components/cars/rear/PORGT";
// import { RRFront } from "../../components/cars/front/RR";
// import { RRRear } from "../../components/cars/rear/RR";
// import { RSRear } from "../../components/cars/rear/RS";
// import { RSFront } from "../../components/cars/front/RS";
// import { TaycanRear } from "../../components/cars/rear/Taycan";
// import { TaycanFront } from "../../components/cars/front/Taycan";
// import { TransporterFront } from "../../components/cars/front/Transporter";
// import { TransporterRear } from "../../components/cars/rear/Transporter";
// import { TrocFront } from "../../components/cars/front/Troc";
// import { TrocRear } from "../../components/cars/rear/Troc";
import download from "../../assets/images/download.svg";
import domtoimage from "dom-to-image";
import Loader from "../../components/Loader";
import { DataContext } from "../../context/dataContext";

const IFront = lazy(() => import("../../components/cars/front/850i"));
const IRear = lazy(() => import("../../components/cars/rear/850i"));
const PORGTFront = lazy(() => import("../../components/cars/front/PORGT"));
const PORGTRear = lazy(() => import("../../components/cars/rear/PORGT"));
const RRFront = lazy(() => import("../../components/cars/front/RR"));
const RRRear = lazy(() => import("../../components/cars/rear/RR"));
const RSRear = lazy(() => import("../../components/cars/rear/RS"));
const RSFront = lazy(() => import("../../components/cars/front/RS"));
const TaycanRear = lazy(() => import("../../components/cars/rear/Taycan"));
const TaycanFront = lazy(() => import("../../components/cars/front/Taycan"));
const TransporterFront = lazy(() =>
  import("../../components/cars/front/Transporter")
);
const TransporterRear = lazy(() =>
  import("../../components/cars/rear/Transporter")
);
const TrocFront = lazy(() => import("../../components/cars/front/Troc"));
const TrocRear = lazy(() => import("../../components/cars/rear/Troc"));

const Plate = (props) => {
  const [numberPlate, setNumberPlate] = useState("");
  const [error, setError] = useState("");
  const dataContext = useContext(DataContext);

  const givenCars = [
    {
      id: 1,
      name: "BMW 850i Front",
      component: (
        <Suspense fallback={<Loader />}>
          <IFront numberPlate={numberPlate} />
        </Suspense>
      ),
    },
    {
      id: 2,
      name: "BMW 850i Rear",
      component: (
        <Suspense fallback={<Loader />}>
          <IRear numberPlate={numberPlate} />
        </Suspense>
      ),
    },
    {
      id: 3,
      name: "Porsche GT Front",
      component: (
        <Suspense fallback={<Loader />}>
          <PORGTFront numberPlate={numberPlate} />
        </Suspense>
      ),
    },
    {
      id: 4,
      name: "Porsche GT Rear",
      component: (
        <Suspense fallback={<Loader />}>
          <PORGTRear numberPlate={numberPlate} />
        </Suspense>
      ),
    },
    {
      id: 5,
      name: "Range Rover Front",
      component: (
        <Suspense fallback={<Loader />}>
          <RRFront numberPlate={numberPlate} />
        </Suspense>
      ),
    },
    {
      id: 6,
      name: "Range Rover Rear",
      component: (
        <Suspense fallback={<Loader />}>
          <RRRear numberPlate={numberPlate} />
        </Suspense>
      ),
    },
    {
      id: 7,
      name: "Audi RS4 Front",
      component: (
        <Suspense fallback={<Loader />}>
          <RSFront numberPlate={numberPlate} />
        </Suspense>
      ),
    },
    {
      id: 8,
      name: "Audi RS4 Rear",
      component: (
        <Suspense fallback={<Loader />}>
          <RSRear numberPlate={numberPlate} />
        </Suspense>
      ),
    },
    {
      id: 9,
      name: "Porsche Taycan Front",
      component: (
        <Suspense fallback={<Loader />}>
          <TaycanFront numberPlate={numberPlate} />
        </Suspense>
      ),
    },
    {
      id: 10,
      name: "Porsche Taycan Rear",
      component: (
        <Suspense fallback={<Loader />}>
          <TaycanRear numberPlate={numberPlate} />
        </Suspense>
      ),
    },
    {
      id: 11,
      name: "Transporter Front",
      component: (
        <Suspense fallback={<Loader />}>
          <TransporterFront numberPlate={numberPlate} />
        </Suspense>
      ),
    },
    {
      id: 12,
      name: "Transporter Rear",
      component: (
        <Suspense fallback={<Loader />}>
          <TransporterRear numberPlate={numberPlate} />
        </Suspense>
      ),
    },
    {
      id: 13,
      name: "T-roc Front",
      component: (
        <Suspense fallback={<Loader />}>
          <TrocFront numberPlate={numberPlate} />
        </Suspense>
      ),
    },
    {
      id: 14,
      name: "T-roc Rear",
      component: (
        <Suspense fallback={<Loader />}>
          <TrocRear numberPlate={numberPlate} />
        </Suspense>
      ),
    },
  ];

  const cars = props?.cars ? [...props?.cars, ...givenCars] : [...givenCars];

  const [selectedCar, setSelectedCar] = useState(cars[0].id);

  const onDownload = (e) => {
    e?.preventDefault();
    if (!numberPlate) {
      setError("Please enter registration");
      return;
    }
    setError("");
    const element = document.querySelector(".genrator__menu--image-inner");
    domtoimage.toPng(element).then((url) => {
      const link = document.createElement("a");
      link.href = url;
      link.download = "download.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  useEffect(() => {
    if (props?.numberPlate) {
      setNumberPlate(props?.numberPlate);
    }
  }, [props]);

  return (
    <div className="main__page__content">
      <main>
        <section className="genrator__menu--section mt-20">
          <div className="container">
            <div className="genrator__menu--inner">
              <div className="genrator__menu--head mb-10">
                {/* <!--header--Text--> */}
                {!props?.isProduct && (
                  <>
                    <h5 className="text-500 text-center fs-4 fys">
                      Generator Menu
                    </h5>
                    <div className="gen-link__inner text-center fys">
                      <span className="fs-6 cursor-not-allowed">
                        Plate Viewer -
                      </span>
                      &nbsp;
                      <a
                        href="#"
                        className="fs-6 text-sky-400 primary-color text-300 fys"
                      >
                        Advert Generator
                      </a>
                    </div>
                  </>
                )}
              </div>
              <div className="genrator__menu--center">
                {/* <!--image--col--> */}
                <div className="genrator__menu--image-inner right-line">
                  <div className="image-div text-center plate-generator-box mx-auto">
                    {/* <Suspense fallback={<Loader />}> */}
                    {
                      cars?.filter((car) => car?.id == selectedCar)[0]
                        ?.component
                    }
                    {/* </Suspense> */}
                  </div>
                </div>
              </div>
              <br />
              {/* <!----> */}
              <div className="genrator__menu--footer">
                <div className="row">
                  <div className="col col-12">
                    <div className="genrator__menu--footer-inner mx-auto">
                      <form
                        action=""
                        id="create-valuation-form"
                        className="form fsi"
                      >
                        {/* <!--text-input--> */}
                        {!props?.isProduct && (
                          <>
                            <h1 className="h2 fs-3 mb-2 text-700 fys">
                              Plate Viewer
                            </h1>
                            <hr />
                            <label htmlFor="reg" className="text-400">
                              {" "}
                              Registration
                            </label>
                            <br />
                            <input
                              type="text"
                              name="reg"
                              maxLength="9"
                              className="w-100 text-400"
                              value={numberPlate}
                              onChange={(e) =>
                                setNumberPlate(e.target.value.trimStart())
                              }
                            />
                            {error && (
                              <div className="text-danger fs-6 mt-1">
                                {error}
                              </div>
                            )}
                            <br />
                          </>
                        )}
                        {/* <!--select-dropdown--> */}
                        <label htmlFor="format" className="text-400 fsi">
                          {" "}
                          Choose a display mode
                        </label>
                        <div className="select__inner">
                          <select
                            name="format"
                            className="select mb-10 w-100 text-400"
                            value={selectedCar}
                            onChange={(e) => setSelectedCar(e.target.value)}
                          >
                            {cars.map((car) => (
                              <option
                                value={car.id}
                                key={car?.id}
                                className="fsi"
                              >
                                {car.name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <br />
                        <br />
                        {/* <!--submit--btn--> */}
                        {!props?.isProduct && (
                          <div className="reg__hero--section p-0">
                            <div className="reg__buy--button d-block">
                              <button
                                type="submit"
                                className="d-flex align-items-center justify-content-center gap-2"
                                onClick={onDownload}
                              >
                                {/* <img
                                      src={download}
                                      alt="download-icon"
                                      className="in-svg w-100 img-fluid m-0 pr-5"
                                    /> */}
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  class="bi bi-download"
                                  viewBox="0 0 16 16"
                                  className="in-svg w-100 img-fluid m-0 pr-5"
                                >
                                  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                                  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                                </svg>
                                Download as image
                              </button>
                            </div>
                          </div>
                        )}
                        <br />
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Plate;
